import _ from 'lodash';

export const selectFndForm = state => _.get(state, ['fndForm'], {});

export const selectFndFormData = state => _.get(selectFndForm(state), ['data'], {});